/// <reference path='../interfaces/interfaces.d.ts' />

'use strict';

angular.module('beneple.global', []);

import './controllers/benefit.controller';
import './controllers/home.controller';
import './controllers/login.controller';
import './controllers/loginmfa.controller';
import './controllers/tour.controller';
import './controllers/report.controller';
import './controllers/sidebar.controller';
import './controllers/topbar.controller';
import './controllers/wizard.controller';
import './controllers/register.controller';
import './controllers/tos';
import './controllers/priv';
import './controllers/helpbox.controller.ts';
import './controllers/tutorials.controller.ts';

import './directives/dropzone_input.directive';
import './directives/dropzone_input_all.directive';
import './directives/file-model.directive';
import './directives/dropzone.directive';
import './directives/pop-over.directive';
import './directives/material.directive';
import './directives/navbar.directive';
import './directives/right_toggle_sidebar.directive';
import './directives/timepicker.directive';
import './directives/toggle_sidebar.directive';
import './directives/infinite-scroll.directive';
import './directives/focus_on_show.directive';
import './directives/inline_edit_emirates_doc_number.directive';
import './directives/inline_edit_text.directive';
import './directives/inline_edit_text_input.directive';
import './directives/inline_edit_number.directive';
import './directives/inline_edit_dropdown.directive';
import './directives/callout.directive';
import './directives/inline_edit_multiple_dropdown.directive';
import './directives/inline_edit_file_upload.directive';
import './directives/inline_edit_date.directive';
import './directives/inline_edit_day.directive';
import './directives/inline_edit_checkbox.directive';
import './directives/inline_edit_time.directive';
import './directives/inline_edit_currency.directive';
import './directives/callout_highlight.directive';
import './directives/inline_employee_select.directive';
import './directives/file_dependant.directive';
import './directives/process_tab.directive';
import './directives/leave_balance_tab.directive';
import './directives/benefits_tab.directive';
import './directives/leave_tab.directive';
import './directives/pending_leave_tab.directive';
import './directives/deleted_leave_tab.directive';
import './directives/insurance_endorsements.directive';
import './directives/insurance_endorsement_employee_table.directive';
import './directives/insurance_endorsement_file_table.directive';
import './directives/insurance_endorsement_employee_select.directive';

import './filters/checkmark.filter';
import './filters/titlecase.filter';
import './filters/fieldtitle.filter';
import './filters/aggregate.filter';
import './filters/moment.filter';
import './filters/localdate.filter';
import './filters/underscoreless.filter';
import './filters/userrole.filter'

import './services/api.service';
import './services/login.service';
import './services/user.service';
import './services/save_inline.service';
import '../enviroments/enviroments.dev'




// WEBPACK FOOTER //
// ./frontend/scripts/global/_module.ts